<div class="w-full p-0 m-0 overflow-hidden" [style.height]="containerHeight">
  <mat-grid-list cols="12" [rowHeight]="'100%'" class="w-full h-full relative">
    <!-- Add these divider elements -->
    <div class="column-divider divider-1"></div>
    <div
      class="column-divider divider-2"
      [class.has-questions]="questions.length > 0"
    ></div>

    <!-- First Column: 20% -->
    <mat-grid-tile [colspan]="2" [rowspan]="1">
      <div class="w-full h-full p-1 box-border overflow-y-auto">
        <div class="space-y-1 p-2">
          @for (type of questionTypes; track type.value) { @if (type.value !==
          'existingTemplate') {
          <button
            (click)="selectQuestionType(type.value)"
            [class.selected-type]="selectedQuestionType === type.value"
            class="w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
            [disabled]="selectedLanguage !== 2"
            [class.disabled-button]="selectedLanguage !== 2"
          >
            <span class="material-icons text-gray-500 mr-3 text-xl">{{
              type.icon
            }}</span>
            <span>{{ type.label }}</span>
          </button>
          } @else {
          <div class="space-y-1">
            <button
              (click)="toggleTemplateMenu()"
              class="w-full flex items-center justify-between px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md transition-colors template-parent-button"
              [class.open]="isTemplateMenuOpen"
              [disabled]="selectedLanguage !== 2"
              [class.disabled-button]="selectedLanguage !== 2"
            >
              <div class="flex items-center">
                <span class="material-icons text-gray-500 mr-3 text-xl">{{
                  type.icon
                }}</span>
                <span>{{ type.label }}</span>
              </div>
              <span
                class="material-icons transform transition-transform"
                [class.rotate-180]="isTemplateMenuOpen"
              >
                expand_more
              </span>
            </button>

            <div
              class="ml-8 template-items-container"
              [class.open]="isTemplateMenuOpen"
            >
              @for (item of templateItems; track item.id) {
              <button
                (click)="selectTemplateItem(item)"
                class="template-item w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
                [disabled]="selectedLanguage !== 2"
                [class.disabled-button]="selectedLanguage !== 2"
              >
                {{ item.name }}
              </button>
              }
            </div>
          </div>
          } }
        </div>
      </div>
    </mat-grid-tile>

    <!-- Second Column: Dynamic width -->
    <mat-grid-tile [colspan]="questions.length ? 7 : 10" [rowspan]="1">
      <div class="w-full h-full p-1 box-border overflow-y-auto">
        <div class="questions-container relative" cdkScrollable>
          <!-- Add empty state when no questions exist -->
          @if (!questions.length) {
          <div
            class="flex flex-col items-center justify-center text-center p-2 max-w-400px m-auto absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full"
          >
            <svg
              width="250"
              height="201"
              viewBox="0 0 250 201"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M207 65.6714C210.866 65.6714 214 68.8054 214 72.6714C214 76.5374 210.866 79.6714 207 79.6714H167C170.866 79.6714 174 82.8054 174 86.6714C174 90.5374 170.866 93.6714 167 93.6714H189C192.866 93.6714 196 96.8054 196 100.671C196 104.537 192.866 107.671 189 107.671H178.826C173.952 107.671 170 110.805 170 114.671C170 117.249 172 119.582 176 121.671C179.866 121.671 183 124.805 183 128.671C183 132.537 179.866 135.671 176 135.671H93C89.134 135.671 86 132.537 86 128.671C86 124.805 89.134 121.671 93 121.671H54C50.134 121.671 47 118.537 47 114.671C47 110.805 50.134 107.671 54 107.671H94C97.866 107.671 101 104.537 101 100.671C101 96.8054 97.866 93.6714 94 93.6714H69C65.134 93.6714 62 90.5374 62 86.6714C62 82.8054 65.134 79.6714 69 79.6714H109C105.134 79.6714 102 76.5374 102 72.6714C102 68.8054 105.134 65.6714 109 65.6714H207ZM207 93.6714C210.866 93.6714 214 96.8054 214 100.671C214 104.537 210.866 107.671 207 107.671C203.134 107.671 200 104.537 200 100.671C200 96.8054 203.134 93.6714 207 93.6714Z"
                fill="#F3F7FF"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M153.671 64.6716L162.973 132.514L163.809 139.321C164.078 141.513 162.519 143.509 160.326 143.778L101.766 150.969C99.5733 151.238 97.5776 149.679 97.3083 147.486L88.2926 74.0583C88.158 72.962 88.9376 71.9641 90.0339 71.8295C90.0408 71.8287 90.0478 71.8278 90.0547 71.8271L94.9131 71.2821M98.8416 70.8414L103.429 70.3269L98.8416 70.8414Z"
                fill="white"
              />
              <path
                d="M154.91 64.5018C154.816 63.8178 154.185 63.3394 153.502 63.4332C152.818 63.5269 152.339 64.1574 152.433 64.8414L154.91 64.5018ZM162.973 132.514L164.214 132.362C164.213 132.356 164.212 132.35 164.212 132.345L162.973 132.514ZM163.809 139.321L165.05 139.168L163.809 139.321ZM160.326 143.778L160.479 145.019L160.326 143.778ZM101.766 150.969L101.918 152.209L101.766 150.969ZM97.3083 147.486L98.549 147.334L97.3083 147.486ZM88.2926 74.0583L87.0519 74.2107L88.2926 74.0583ZM90.0547 71.8271L90.1941 73.0693L90.0547 71.8271ZM95.0524 72.5243C95.7385 72.4473 96.2322 71.8288 96.1553 71.1427C96.0783 70.4567 95.4598 69.9629 94.7737 70.0399L95.0524 72.5243ZM98.7023 69.5992C98.0162 69.6761 97.5224 70.2947 97.5994 70.9807C97.6764 71.6668 98.2949 72.1606 98.981 72.0836L98.7023 69.5992ZM103.568 71.5691C104.254 71.4921 104.748 70.8736 104.671 70.1875C104.594 69.5015 103.975 69.0077 103.289 69.0846L103.568 71.5691ZM152.433 64.8414L161.735 132.684L164.212 132.345L154.91 64.5018L152.433 64.8414ZM161.733 132.667L162.568 139.473L165.05 139.168L164.214 132.362L161.733 132.667ZM162.568 139.473C162.753 140.98 161.681 142.353 160.174 142.538L160.479 145.019C163.356 144.666 165.403 142.046 165.05 139.168L162.568 139.473ZM160.174 142.538L101.614 149.728L101.918 152.209L160.479 145.019L160.174 142.538ZM101.614 149.728C100.106 149.913 98.7341 148.841 98.549 147.334L96.0677 147.638C96.421 150.516 99.0404 152.563 101.918 152.209L101.614 149.728ZM98.549 147.334L89.5332 73.906L87.0519 74.2107L96.0677 147.638L98.549 147.334ZM89.5332 73.906C89.4828 73.4949 89.7751 73.1207 90.1863 73.0702L89.8816 70.5888C88.1 70.8076 86.8331 72.4291 87.0519 74.2107L89.5332 73.906ZM90.1863 73.0702C90.1889 73.0699 90.1915 73.0696 90.1941 73.0693L89.9154 70.5849C89.9041 70.5861 89.8928 70.5874 89.8816 70.5888L90.1863 73.0702ZM90.1941 73.0693L95.0524 72.5243L94.7737 70.0399L89.9154 70.5849L90.1941 73.0693ZM98.981 72.0836L103.568 71.5691L103.289 69.0846L98.7023 69.5992L98.981 72.0836Z"
                fill="#1F64E7"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M151.141 68.9405L159.56 130.424L160.318 136.592C160.562 138.58 159.168 140.386 157.204 140.627L104.762 147.066C102.798 147.307 101.009 145.892 100.765 143.905L92.6148 77.5281C92.4802 76.4317 93.2598 75.4338 94.3562 75.2992L100.844 74.5027"
                fill="#E8F0FE"
              />
              <path
                d="M107.922 54.6714C107.922 53.1526 109.153 51.9214 110.672 51.9214H156.229C156.958 51.9214 157.657 52.2109 158.173 52.7262L171.616 66.1612C172.132 66.6769 172.422 67.3767 172.422 68.1063V130.671C172.422 132.19 171.191 133.421 169.672 133.421H110.672C109.153 133.421 107.922 132.19 107.922 130.671V54.6714Z"
                fill="white"
                stroke="#1F64E7"
                stroke-width="2.5"
              />
              <path
                d="M156.672 53.0742V64.6714C156.672 66.3282 158.015 67.6714 159.672 67.6714H167.605"
                stroke="#1F64E7"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M118 118.671H144M118 67.6714H144H118ZM118 79.6714H161H118ZM118 92.6714H161H118ZM118 105.671H161H118Z"
                stroke="#75A4FE"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div class="text-2xl font-bold">Your form is empty</div>
            <div
              class="text-1xl text-gray-500 mt-2 text-center max-w-300px m-auto mb-2"
            >
              Click on element from the toolbox or click the button below to
              create question
            </div>
            <button
              mat-raised-button
              class="full-width-button"
              (click)="addQuestion()"
            >
              Add Question
            </button>
          </div>
          }

          <!-- Existing questions list -->
          @if (questions.length) {
          <div
            cdkDropList
            (cdkDropListDropped)="onQuestionDrop($event)"
            class="questions-list overflow-visible"
            cdkDropListAutoScrollStep="500"
            cdkDropListAutoScrollDisabled="false"
          >
            @for (questionForm of questions; track $index; let i = $index) {
            <mat-card
              class="question-card w-full mb-2 cursor-pointer"
              [class.selected]="isQuestionSelected(i)"
              (click)="selectQuestion(i, $event)"
              cdkDrag
            >
              <div
                class="question-drag-handle cdkDragHandle flex items-center justify-center p-2 cursor-move w-full"
              >
                <mat-icon class="text-gray-600">drag_indicator</mat-icon>
              </div>
              <mat-card-content
                [formGroup]="questionForm"
                class="flex flex-col p-3"
              >
                <div class="mb-4">
                  <div class="question-text-container flex items-center mb-2">
                    @if (questionForm.get('fieldTypeId')?.value !== 7 &&
                    questionForm.get('fieldTypeId')?.value !== 6) {
                    <div class="custom-input-container w-full">
                      <input
                        class="custom-input w-full"
                        [formControlName]="'label'"
                        [placeholder]="
                          'DYNAMIC_FORM.QUESTION.LABEL' | translate
                        "
                      />
                    </div>
                    } @else if (questionForm.get('fieldTypeId')?.value === 7) {
                    <div class="w-full">
                      <div class="flex items-center justify-between mb-4">
                        <span
                          class="question-label flex-1 p-2 flex items-center font-medium text-gray-700"
                          [class.sellout-label]="
                            questionForm.get('fieldTypeId')?.value === 7
                          "
                        >
                          {{ questionForm.get('label')?.value | translate }}
                        </span>
                      </div>

                      <!-- Search and Category/Subcategory Section -->
                      <div class="bg-white rounded-lg p-4 mb-4">
                        <div class="mb-4">
                          <div class="relative">
                            <input
                              type="text"
                              placeholder="{{
                                'DYNAMIC_FORM.SELLOUT.SEARCH' | translate
                              }}"
                              class="w-full h-10 pl-10 pr-4 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500"
                              disabled
                            />
                            <span
                              class="material-icons absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                            >
                              search
                            </span>
                          </div>
                        </div>

                        <div class="grid grid-cols-2 gap-4">
                          <div>
                            <label
                              class="block text-sm font-medium text-gray-700 mb-1"
                              >{{
                                'DYNAMIC_FORM.SELLOUT.CATEGORY' | translate
                              }}*</label
                            >
                            <div class="relative">
                              <select
                                class="w-full h-10 pl-3 pr-10 text-sm border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white"
                                disabled
                              >
                                <option>
                                  {{
                                    'DYNAMIC_FORM.SELLOUT.SELECT' | translate
                                  }}
                                </option>
                              </select>
                              <span
                                class="material-icons absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                              >
                                expand_more
                              </span>
                            </div>
                          </div>

                          <div>
                            <label
                              class="block text-sm font-medium text-gray-700 mb-1"
                              >{{
                                'DYNAMIC_FORM.SELLOUT.SUBCATEGORY' | translate
                              }}*</label
                            >
                            <div class="relative">
                              <select
                                class="w-full h-10 pl-3 pr-10 text-sm border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white"
                                disabled
                              >
                                <option>Select</option>
                              </select>
                              <span
                                class="material-icons absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                              >
                                expand_more
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    }
                  </div>

                  @if (questionForm.get('fieldTypeId')?.value === 4 ||
                  questionForm.get('fieldTypeId')?.value === 9) {
                  <div class="mt-2">
                    <div
                      formArrayName="options"
                      cdkDropList
                      (cdkDropListDropped)="onOptionDrop(questionForm, $event)"
                    >
                      @for (option of
                      getOptionsFormArray(questionForm).controls; track $index;
                      let j = $index) {
                      <div
                        class="flex items-center gap-0 mb-2 cursor-default bg-white h-10"
                        cdkDrag
                        [formGroupName]="j"
                      >
                        <div
                          class="flex items-center text-gray-600 mr-2 h-full cursor-move"
                          cdkDragHandle
                        >
                          <mat-icon>drag_indicator</mat-icon>
                        </div>
                        @if (getOptionsFormArray(questionForm).length > 2) {
                        <button
                          mat-icon-button
                          class="flex items-center mr-2 h-full remove-option-button"
                          (click)="removeOption(questionForm, j)"
                        >
                          <mat-icon>remove_circle_outline</mat-icon>
                        </button>
                        } @if (questionForm.get('fieldTypeId')?.value === 4) {
                        <mat-radio-button
                          [checked]="false"
                          class="mr-2 pointer-events-none flex items-center"
                          [disabled]="true"
                        ></mat-radio-button>
                        } @if (questionForm.get('fieldTypeId')?.value === 9) {
                        <mat-checkbox
                          [checked]="false"
                          class="mr-2 pointer-events-none flex items-center"
                          [disabled]="true"
                        ></mat-checkbox>
                        }
                        <div class="custom-input-container flex-1">
                          <input
                            class="custom-input w-full"
                            [formControlName]="'label'"
                            [placeholder]="
                              'DYNAMIC_FORM.QUESTION.OPTION_PLACEHOLDER'
                                | translate : { number: j + 1 }
                            "
                          />
                        </div>
                      </div>
                      }
                    </div>
                    <button
                      mat-button
                      color="primary"
                      (click)="addOption(questionForm)"
                      [disabled]="selectedLanguage !== 2"
                      [class.disabled-button]="selectedLanguage !== 2"
                    >
                      {{ 'DYNAMIC_FORM.QUESTION.ADD_OPTION' | translate }}
                    </button>
                  </div>
                  } @if (questionForm.get('fieldTypeId')?.value === 8) {
                  <div class="yes-no flex gap-2 mt-2">
                    <div class="w-[20%]">
                      <input
                        class="yes-no-input"
                        [formControl]="
                          $any(
                            getOptionsFormArray(questionForm).at(0).get('label')
                          )
                        "
                        [placeholder]="
                          'DYNAMIC_FORM.QUESTION.YES_PLACEHOLDER' | translate
                        "
                      />
                    </div>
                    <div class="w-[20%]">
                      <input
                        class="yes-no-input"
                        [formControl]="
                          $any(
                            getOptionsFormArray(questionForm).at(1).get('label')
                          )
                        "
                        [placeholder]="
                          'DYNAMIC_FORM.QUESTION.NO_PLACEHOLDER' | translate
                        "
                      />
                    </div>
                  </div>
                  } @if (questionForm.get('fieldTypeId')?.value === 2) {
                  <div
                    class="border-2 border-dashed border-gray-300 rounded-lg p-6 mt-4 mb-10"
                  >
                    <div
                      class="flex flex-col items-center justify-center text-center"
                    >
                      <p class="text-gray-600 mb-2">
                        {{ 'DYNAMIC_FORM.QUESTION.DRAG_DROP' | translate }}
                      </p>
                    </div>
                  </div>
                  } @if (questionForm.get('fieldTypeId')?.value === 1) {
                  <div class="custom-input-container-text-field">
                    <input
                      class="custom-input-text-field mb-10"
                      [disabled]="true"
                      [value]="
                        'DYNAMIC_FORM.QUESTION.TEXT_PLACEHOLDER' | translate
                      "
                    />
                  </div>
                  }

                  <!-- Add Table Components section -->
                  @if (questionForm.get('fieldTypeId')?.value === 7) {
                  <div class="mt-6">
                    <h3 class="text-base font-medium text-gray-700 mb-4">
                      {{ 'DYNAMIC_FORM.SELLOUT.TABLE_COMPONENTS' | translate }}
                    </h3>
                    <div class="grid grid-cols-2 gap-4">
                      @for (field of
                      getChildrenFormArray(questionForm).controls; track field)
                      {
                      <div class="relative">
                        <div class="flex items-center justify-between mb-1">
                          <div class="flex-1">
                            <!-- For default sellout fields, show translated value but keep translation key in form control -->
                            @if
                            (isSelloutDefaultField(field.get('label')?.value)) {
                            <div
                              class="w-full text-sm font-medium text-gray-700"
                            >
                              {{ field.get('label')?.value | translate }}
                            </div>
                            } @else {
                            <input
                              [formControl]="$any(field.get('label'))"
                              class="w-full text-sm font-medium text-gray-700 border-none bg-transparent focus:outline-none"
                              placeholder="{{
                                'DYNAMIC_FORM.SELLOUT.FIELD_LABEL' | translate
                              }}"
                            />
                            }
                          </div>
                          <button
                            mat-icon-button
                            class="flex items-center mr-2 h-full remove-option-button"
                            (click)="removeTableField(questionForm, field)"
                            [disabled]="
                              isSalesDateField(field.get('label')?.value)
                            "
                            [class.disabled-remove-button]="
                              isSalesDateField(field.get('label')?.value)
                            "
                          >
                            <mat-icon>remove_circle_outline</mat-icon>
                          </button>
                        </div>
                        <div class="relative">
                          <mat-form-field class="w-full">
                            <mat-select
                              [formControl]="$any(field.get('fieldTypeId'))"
                            >
                              <mat-option [value]="5">Number</mat-option>
                              <mat-option [value]="1">Text Field</mat-option>
                              <mat-option [value]="12">Attachment</mat-option>
                              <mat-option [value]="14">Date</mat-option>
                              <mat-option [value]="7"
                                >Increment Decrement</mat-option
                              >
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                      }
                    </div>
                    <button
                      mat-stroked-button
                      color="primary"
                      class="mt-4 w-full mb-8"
                      (click)="addTableField(questionForm)"
                      [disabled]="selectedLanguage !== 2"
                      [class.disabled-button]="selectedLanguage !== 2"
                    >
                      {{ 'DYNAMIC_FORM.SELLOUT.ADD_FIELD' | translate }}
                    </button>
                  </div>
                  }

                  <!-- Store360 Fields -->
                  @if (questionForm.get('fieldTypeId')?.value === 6) {
                  <div class="w-full">
                    <div class="flex items-center mb-4">
                      <span
                        class="question-label flex items-center font-medium text-gray-700"
                      >
                        Store360
                      </span>
                    </div>
                    <div class="grid grid-cols-1 gap-4">
                      @for (field of
                      getChildrenFormArray(questionForm).controls; track field)
                      {
                      <div
                        class="bg-white rounded-lg p-4 border-2 border-gray-300 shadow-lg relative store360-card question-card"
                        [class.invalid]="
                          field.get('label')?.invalid &&
                          field.get('label')?.touched
                        "
                      >
                        <div class="custom-input-container w-full mb-4">
                          <input
                            class="custom-input w-full"
                            [formControl]="$any(field.get('label'))"
                            [placeholder]="
                              'DYNAMIC_FORM.QUESTION.LABEL' | translate
                            "
                          />
                        </div>

                        <!-- Add Note field -->
                        <div class="mb-4">
                          <label
                            class="block text-sm font-medium text-gray-700 mb-2"
                            >Add Note</label
                          >
                          <div class="custom-input-container">
                            <input
                              type="text"
                              class="custom-input w-full"
                              placeholder="Enter Note"
                              [formControl]="$any(field.get('note'))"
                            />
                          </div>
                        </div>

                        <div class="grid grid-cols-2 gap-4">
                          <div>
                            <label
                              class="block text-sm font-medium text-gray-700 mb-2"
                              >Upload Image</label
                            >
                            <div class="relative">
                              <select
                                class="w-full h-10 pl-3 pr-10 text-sm border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 bg-gray-50"
                                disabled
                              >
                                <option>Attachment</option>
                              </select>
                              <span
                                class="material-icons absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                              >
                                expand_more
                              </span>
                            </div>
                          </div>

                          <div>
                            <label
                              class="block text-sm font-medium text-gray-700 mb-2"
                              >Description</label
                            >
                            <div class="relative">
                              <select
                                class="w-full h-10 pl-3 pr-10 text-sm border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 bg-gray-50"
                                disabled
                              >
                                <option>Text Field</option>
                              </select>
                              <span
                                class="material-icons absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                              >
                                expand_more
                              </span>
                            </div>
                          </div>
                        </div>

                        <!-- Actions -->
                        <div
                          class="store360-card-actions absolute bottom-2 right-2 flex items-center justify-end gap-2 opacity-0 transition-opacity duration-200 ease-in-out hover:opacity-100"
                        >
                          <mat-checkbox
                            class="store360-mandatory-checkbox"
                            [checked]="field.get('required')?.value"
                            (change)="
                              onStore360MandatoryChange(
                                $event,
                                questionForm,
                                field
                              )
                            "
                            matTooltip="Mandatory"
                            matTooltipPosition="above"
                          >
                            Mandatory
                          </mat-checkbox>
                          <button
                            mat-icon-button
                            class="store360-delete-button flex items-center justify-center h-9 w-9"
                            (click)="removeStore360Field(questionForm, field)"
                            matTooltip="Delete"
                            matTooltipPosition="above"
                          >
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </div>
                      }
                    </div>

                    <!-- Add New Field button -->
                    <button
                      mat-stroked-button
                      color="primary"
                      class="mt-4 w-full mb-8"
                      (click)="addStore360Field(questionForm)"
                      [disabled]="selectedLanguage !== 2"
                      [class.disabled-button]="selectedLanguage !== 2"
                    >
                      Add New Field
                    </button>
                  </div>
                  }

                  <!-- Display Planogram -->
                  @if (questionForm.get('fieldTypeId')?.value === 15) {
                  <div class="w-full">
                    <!-- Table Components section -->
                    <div class="grid grid-cols-2 gap-4">
                      @for (field of
                      getChildrenFormArray(questionForm).controls; track field)
                      {
                      <div class="relative">
                        <div class="flex items-center justify-between mb-2">
                          @if
                          (isDisplayPlanogramDefaultField(field.get('label')?.value))
                          {
                          <label
                            class="block text-sm font-medium text-gray-700"
                          >
                            {{ field.get('label')?.value | translate }}
                          </label>
                          } @else {
                          <!-- For dynamic fields, show editable input -->
                          <input
                            [formControl]="$any(field.get('label'))"
                            class="w-full text-sm font-medium text-gray-700 border-none bg-transparent focus:outline-none"
                            placeholder="Field Label"
                          />
                          }
                          <!-- Add delete button for all fields if there's more than one field -->
                          @if (canRemoveField(questionForm, field)) {
                          <button
                            mat-icon-button
                            class="flex items-center mr-2 h-full remove-option-button"
                            (click)="removeTableField(questionForm, field)"
                          >
                            <mat-icon>remove_circle_outline</mat-icon>
                          </button>
                          }
                        </div>
                        <mat-form-field class="w-full">
                          <mat-select
                            [formControl]="$any(field.get('fieldTypeId'))"
                          >
                            @for (type of displayPlanogramFieldTypes; track
                            type) {
                            <mat-option [value]="type.value">{{
                              type.label
                            }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      }
                    </div>

                    <!-- Add Field button -->
                    <button
                      mat-stroked-button
                      color="primary"
                      class="mt-4 w-full mb-8"
                      (click)="addDisplayPlanogramField(questionForm)"
                      [disabled]="selectedLanguage !== 2"
                      [class.disabled-button]="selectedLanguage !== 2"
                    >
                      Add Field
                    </button>
                  </div>
                  }

                  <!-- Display Share Template -->
                  @if (questionForm.get('fieldTypeId')?.value === 16) {
                  <div class="w-full">
                    <!-- Table Components section -->
                    <div class="grid grid-cols-2 gap-4">
                      @for (field of
                      getChildrenFormArray(questionForm).controls; track field)
                      {
                      <div class="relative">
                        <div class="flex items-center justify-between mb-2">
                          @if
                          (isDisplayShareDefaultField(field.get('label')?.value))
                          {
                          <label
                            class="block text-sm font-medium text-gray-700"
                          >
                            {{ field.get('label')?.value | translate }}
                          </label>
                          } @else {
                          <!-- For dynamic fields, show editable input -->
                          <input
                            [formControl]="$any(field.get('label'))"
                            class="w-full text-sm font-medium text-gray-700 border-none bg-transparent focus:outline-none"
                            placeholder="Field Label"
                          />
                          }
                          <!-- Add delete button for all fields if there's more than one field -->
                          @if (canRemoveField(questionForm, field)) {
                          <button
                            mat-icon-button
                            class="flex items-center mr-2 h-full remove-option-button"
                            (click)="removeTableField(questionForm, field)"
                          >
                            <mat-icon>remove_circle_outline</mat-icon>
                          </button>
                          }
                        </div>
                        <mat-form-field class="w-full">
                          <mat-select
                            [formControl]="$any(field.get('fieldTypeId'))"
                          >
                            @for (type of displayPlanogramFieldTypes; track
                            type) {
                            <mat-option [value]="type.value">{{
                              type.label
                            }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      }
                    </div>

                    <!-- Add Field button -->
                    <button
                      mat-stroked-button
                      color="primary"
                      class="mt-4 w-full mb-8"
                      (click)="addDisplayShareField(questionForm)"
                      [disabled]="selectedLanguage !== 2"
                      [class.disabled-button]="selectedLanguage !== 2"
                    >
                      Add Field
                    </button>
                  </div>
                  }

                  <!-- POSM Deployment -->
                  @if (questionForm.get('fieldTypeId')?.value === 17) {
                  <div class="w-full">
                    <!-- POSM Fields Section -->
                    <div class="bg-white rounded-lg p-4 mb-4">
                      <div class="grid grid-cols-2 gap-4 mb-4">
                        <!-- Category Dropdown -->
                        <div>
                          <label
                            class="block text-sm font-medium text-gray-700 mb-1"
                            >Category*</label
                          >
                          <div class="relative">
                            <select
                              class="w-full h-10 pl-3 pr-10 text-sm border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white"
                              disabled
                            >
                              <option>Select</option>
                            </select>
                            <span
                              class="material-icons absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                            >
                              expand_more
                            </span>
                          </div>
                        </div>

                        <!-- Sub-category Dropdown -->
                        <div>
                          <label
                            class="block text-sm font-medium text-gray-700 mb-1"
                            >Sub-category*</label
                          >
                          <div class="relative">
                            <select
                              class="w-full h-10 pl-3 pr-10 text-sm border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white"
                              disabled
                            >
                              <option>Select</option>
                            </select>
                            <span
                              class="material-icons absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                            >
                              expand_more
                            </span>
                          </div>
                        </div>
                      </div>

                      <!-- Model Dropdown (Full Width) -->
                      <div class="mb-6">
                        <label
                          class="block text-sm font-medium text-gray-700 mb-1"
                          >Model*</label
                        >
                        <div class="relative">
                          <select
                            class="w-full h-10 pl-3 pr-10 text-sm border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white"
                            disabled
                          >
                            <option>Select</option>
                          </select>
                          <span
                            class="material-icons absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                          >
                            expand_more
                          </span>
                        </div>
                      </div>

                      <!-- Table Components section -->
                      <div class="mt-6">
                        <h3 class="text-base font-medium text-gray-700 mb-4">
                          Table Components
                        </h3>
                        <div class="grid grid-cols-2 gap-4">
                          @for (field of
                          getChildrenFormArray(questionForm).controls; track
                          field) {
                          <div class="relative">
                            <div class="flex items-center justify-between mb-1">
                              <div class="flex-1">
                                <!-- Check if it's a default field (dropdown) -->
                                @if
                                (isPosmDefaultField(field.get('label')?.value))
                                {
                                <label
                                  class="text-sm font-medium text-gray-700"
                                >
                                  {{ field.get('label')?.value }}
                                </label>
                                } @else {
                                <!-- Make label editable for non-default fields -->
                                <input
                                  [formControl]="$any(field.get('label'))"
                                  class="w-full text-sm font-medium text-gray-700 border-none bg-transparent focus:outline-none"
                                  placeholder="Field Label"
                                />
                                }
                              </div>
                              <!-- Add remove button -->
                              <button
                                mat-icon-button
                                class="flex items-center mr-2 h-full remove-option-button"
                                (click)="removeTableField(questionForm, field)"
                                [disabled]="
                                  canRemoveField(questionForm, field) === false
                                "
                                [class.disabled-remove-button]="
                                  canRemoveField(questionForm, field) === false
                                "
                              >
                                <mat-icon>remove_circle_outline</mat-icon>
                              </button>
                            </div>
                            <div class="relative">
                              <mat-form-field class="w-full">
                                <mat-select
                                  [formControl]="$any(field.get('fieldTypeId'))"
                                >
                                  @for (type of posmFieldTypes; track type) {
                                  <mat-option [value]="type.value">{{
                                    type.label
                                  }}</mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                          }
                        </div>

                        <!-- Add Field button -->
                        <button
                          mat-stroked-button
                          color="primary"
                          class="mt-4 w-full mb-8"
                          (click)="addPosmField(questionForm)"
                          [disabled]="selectedLanguage !== 2"
                          [class.disabled-button]="selectedLanguage !== 2"
                        >
                          Add Field
                        </button>
                      </div>
                    </div>
                  </div>
                  }

                  <!-- Date Field -->
                  @if (questionForm.get('fieldTypeId')?.value === 12) {
                  <div class="mb-4">
                    <div class="flex justify-center items-center mt-4 mb-10">
                      <mat-calendar
                        [startAt]="today"
                        disabled
                        class="opacity-70 pointer-events-none w-[250px] h-auto"
                      >
                      </mat-calendar>
                    </div>
                  </div>
                  }

                  <!-- Promoter Share -->
                  @if (questionForm.get('fieldTypeId')?.value === 18) {
                  <div class="w-full">
                    <!-- <div class="flex items-center mb-4">
                      <span
                        class="question-label flex items-center font-medium text-gray-700"
                      >
                        Promoter Share
                      </span>
                    </div> -->

                    <!-- Brand field (disabled) -->
                    <div class="bg-white rounded-lg p-4 mb-4">
                      <div class="mb-4">
                        <label
                          class="block text-sm font-medium text-gray-700 mb-1"
                          >Brand*</label
                        >
                        <div class="relative">
                          <select
                            class="w-full h-10 pl-3 pr-10 text-sm border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white"
                            disabled
                          >
                            <option>Select</option>
                          </select>
                          <span
                            class="material-icons absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                          >
                            expand_more
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Table Components section -->
                    <div class="mt-6">
                      <h3 class="text-base font-medium text-gray-700 mb-4">
                        Table Components
                      </h3>
                      <div class="grid grid-cols-2 gap-4">
                        @for (field of
                        getChildrenFormArray(questionForm).controls; track
                        field) {
                        <div class="relative">
                          <div class="flex items-center justify-between mb-1">
                            <div class="flex-1">
                              <!-- For default promoter share fields, show translated value but keep translation key in form control -->
                              @if
                              (isPromoterShareDefaultField(field.get('label')?.value))
                              {
                              <div
                                class="w-full text-sm font-medium text-gray-700"
                              >
                                {{ field.get('label')?.value | translate }}
                              </div>
                              } @else {
                              <input
                                [formControl]="$any(field.get('label'))"
                                class="w-full text-sm font-medium text-gray-700 border-none bg-transparent focus:outline-none"
                                placeholder="Field Label"
                              />
                              }
                            </div>
                            <button
                              mat-icon-button
                              class="flex items-center mr-2 h-full remove-option-button"
                              (click)="removeTableField(questionForm, field)"
                              [disabled]="
                                field.get('label')?.value ===
                                'DYNAMIC_FORM.PROMOTER_SHARE.BRAND'
                              "
                              [class.disabled-remove-button]="
                                field.get('label')?.value ===
                                'DYNAMIC_FORM.PROMOTER_SHARE.BRAND'
                              "
                            >
                              <mat-icon>remove_circle_outline</mat-icon>
                            </button>
                          </div>
                          <div class="relative">
                            <mat-form-field class="w-full">
                              <mat-select
                                [formControl]="$any(field.get('fieldTypeId'))"
                              >
                                <mat-option [value]="7"
                                  >Increment Decrement</mat-option
                                >
                                <mat-option [value]="5">Number</mat-option>
                                <mat-option [value]="1">Text Field</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                        }
                      </div>
                      <button
                        mat-stroked-button
                        color="primary"
                        class="mt-4 w-full mb-8"
                        (click)="addPromoterShareField(questionForm)"
                        [disabled]="selectedLanguage !== 2"
                        [class.disabled-button]="selectedLanguage !== 2"
                      >
                        Add Field
                      </button>
                    </div>
                  </div>
                  }

                  <!-- Shop Profiling -->
                  @if (questionForm.get('fieldTypeId')?.value === 20) {
                  <div class="w-full">
                    <!-- Dropdown Fields Section -->
                    <div class="bg-white rounded-lg p-4 mb-4">
                      <div class="grid grid-cols-2 gap-4 mb-4">
                        <!-- Category Dropdown -->
                        <div>
                          <label
                            class="block text-sm font-medium text-gray-700 mb-1"
                            >Category*</label
                          >
                          <div class="relative">
                            <select
                              class="w-full h-10 pl-3 pr-10 text-sm border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white"
                              disabled
                            >
                              <option>Select</option>
                            </select>
                            <span
                              class="material-icons absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                            >
                              expand_more
                            </span>
                          </div>
                        </div>

                        <!-- Sub-category Dropdown -->
                        <div>
                          <label
                            class="block text-sm font-medium text-gray-700 mb-1"
                            >Sub-category*</label
                          >
                          <div class="relative">
                            <select
                              class="w-full h-10 pl-3 pr-10 text-sm border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white"
                              disabled
                            >
                              <option>Select</option>
                            </select>
                            <span
                              class="material-icons absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                            >
                              expand_more
                            </span>
                          </div>
                        </div>
                      </div>

                      <!-- Segment Dropdown (Full Width) -->
                      <div class="mb-6">
                        <label
                          class="block text-sm font-medium text-gray-700 mb-1"
                          >Segment*</label
                        >
                        <div class="relative">
                          <select
                            class="w-full h-10 pl-3 pr-10 text-sm border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white"
                            disabled
                          >
                            <option>Select</option>
                          </select>
                          <span
                            class="material-icons absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                          >
                            expand_more
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Table Components section -->
                    <div class="mt-6">
                      <h3 class="text-base font-medium text-gray-700 mb-4">
                        Table Components
                      </h3>
                      <div class="grid grid-cols-2 gap-4">
                        @for (field of
                        getChildrenFormArray(questionForm).controls; track
                        field) {
                        <div class="relative">
                          <div class="flex items-center justify-between mb-1">
                            <div class="flex-1">
                              <!-- Check if it's a default field -->
                              @if
                              (isShopProfilingDefaultField(field.get('label')?.value))
                              {
                              <label class="text-sm font-medium text-gray-700">
                                {{ field.get('label')?.value }}
                              </label>
                              } @else {
                              <!-- Make label editable for non-default fields -->
                              <input
                                [formControl]="$any(field.get('label'))"
                                class="w-full text-sm font-medium text-gray-700 border-none bg-transparent focus:outline-none"
                                placeholder="Field Label"
                              />
                              }
                            </div>
                            <!-- Add remove button -->
                            <button
                              mat-icon-button
                              class="flex items-center mr-2 h-full remove-option-button"
                              (click)="removeTableField(questionForm, field)"
                              [disabled]="
                                canRemoveField(questionForm, field) === false
                              "
                              [class.disabled-remove-button]="
                                canRemoveField(questionForm, field) === false
                              "
                            >
                              <mat-icon>remove_circle_outline</mat-icon>
                            </button>
                          </div>
                          <div class="relative">
                            <mat-form-field class="w-full">
                              <mat-select
                                [formControl]="$any(field.get('fieldTypeId'))"
                              >
                                @for (type of shopProfilingFieldTypes; track
                                type) {
                                <mat-option [value]="type.value">{{
                                  type.label
                                }}</mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                        }
                      </div>

                      <!-- Add Field button -->
                      <button
                        mat-stroked-button
                        color="primary"
                        class="mt-4 w-full mb-8"
                        (click)="addShopProfilingField(questionForm)"
                        [disabled]="selectedLanguage !== 2"
                        [class.disabled-button]="selectedLanguage !== 2"
                      >
                        Add Field
                      </button>
                    </div>
                  </div>
                  }

                  <!-- Market Activities -->
                  @if (questionForm.get('fieldTypeId')?.value === 21) {
                  <div class="w-full">
                    <!-- Table Components section -->
                    <div class="grid grid-cols-2 gap-4">
                      @for (field of
                      getChildrenFormArray(questionForm).controls; track field)
                      {
                      <div class="relative">
                        <div class="flex items-center justify-between mb-2">
                          @if
                          (isMarketActivitiesDefaultField(field.get('label')?.value))
                          {
                          <label
                            class="block text-sm font-medium text-gray-700"
                          >
                            {{ field.get('label')?.value | translate }}
                          </label>
                          } @else {
                          <!-- For dynamic fields, show editable input -->
                          <input
                            [formControl]="$any(field.get('label'))"
                            class="w-full text-sm font-medium text-gray-700 border-none bg-transparent focus:outline-none"
                            placeholder="Field Label"
                          />
                          }
                          <!-- Add delete button for all fields if there's more than one field -->
                          @if (canRemoveField(questionForm, field)) {
                          <button
                            mat-icon-button
                            class="flex items-center mr-2 h-full remove-option-button"
                            (click)="removeTableField(questionForm, field)"
                          >
                            <mat-icon>remove_circle_outline</mat-icon>
                          </button>
                          }
                        </div>
                        <mat-form-field class="w-full">
                          <mat-select
                            [formControl]="$any(field.get('fieldTypeId'))"
                          >
                            @for (type of marketActivitiesFieldTypes; track
                            type) {
                            <mat-option [value]="type.value">{{
                              type.label
                            }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      }
                    </div>

                    <!-- Add Field button -->
                    <button
                      mat-stroked-button
                      color="primary"
                      class="mt-4 w-full mb-8"
                      (click)="addMarketActivitiesField(questionForm)"
                      [disabled]="selectedLanguage !== 2"
                      [class.disabled-button]="selectedLanguage !== 2"
                    >
                      Add Field
                    </button>
                  </div>
                  }
                </div>
                <div
                  class="action-buttons absolute bottom-2 right-2 flex items-center gap-1"
                >
                  @if (questionForm.get('fieldTypeId')?.value !== 7 &&
                  questionForm.get('fieldTypeId')?.value !== 6 &&
                  questionForm.get('fieldTypeId')?.value !== 15 &&
                  questionForm.get('fieldTypeId')?.value !== 16 &&
                  questionForm.get('fieldTypeId')?.value !== 17 &&
                  questionForm.get('fieldTypeId')?.value !== 18 &&
                  questionForm.get('fieldTypeId')?.value !== 20 &&
                  questionForm.get('fieldTypeId')?.value !== 21) {
                  <button
                    mat-icon-button
                    matTooltip="Duplicate"
                    matTooltipPosition="above"
                    (click)="duplicateQuestion(i, $event)"
                  >
                    <mat-icon>content_copy</mat-icon>
                  </button>
                  }
                  <button
                    mat-icon-button
                    class="delete-button"
                    (click)="deleteQuestion(i); $event.stopPropagation()"
                    matTooltip="Delete"
                    matTooltipPosition="above"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
            }
          </div>
          <button
            mat-raised-button
            class="w-full mt-2"
            (click)="addQuestion()"
            [disabled]="selectedLanguage !== 2"
            [class.disabled-button]="selectedLanguage !== 2"
          >
            Add Question
          </button>

          <!-- Update the buttons container -->
          <div class="flex justify-end gap-2 mt-4">
            <button
              mat-stroked-button
              class="px-4 py-2 text-gray-700 bg-gray-100 rounded hover:bg-gray-200"
              (click)="cancelForm()"
            >
              Cancel
            </button>
            <button mat-stroked-button (click)="saveForm()">Save</button>
            <button
              mat-raised-button
              color="primary"
              [disabled]="!areAllLanguagesSaved"
              (click)="publishSurvey()"
            >
              Publish
            </button>
          </div>
          }
        </div>
      </div>
    </mat-grid-tile>

    <!-- Third Column: 20% (only shown when questions exist) -->
    @if (questions.length) {
    <mat-grid-tile [colspan]="3" [rowspan]="1">
      <div class="w-full h-full p-1 box-border overflow-y-auto">
        <div class="conditions-container">
          <!-- Language selector - always enabled -->
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Select Language
            </label>
            <mat-form-field class="w-full">
              <mat-select
                [formControl]="languageControl"
                [(value)]="selectedLanguage"
                (selectionChange)="onLanguageChange($event)"
              >
                @for (lang of availableLanguages; track lang.id) {
                <mat-option [value]="lang.id">{{ lang.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Add header and container for saved languages -->
          <div class="mt-6 border-t border-gray-200 pt-4">
            <h3 class="text-base font-medium text-gray-700 mb-3">
              Saved Languages
            </h3>

            @if (savedLanguages.length > 0) {
            <div class="flex flex-wrap gap-2 min-h-[32px] py-1 mb-8">
              @for (lang of savedLanguages; track lang.id) {
              <div class="saved-language-chip flex items-center gap-2">
                {{ lang.name }}
                <mat-icon
                  class="cursor-pointer"
                  (click)="removeLanguage(lang, $event)"
                >
                  close
                </mat-icon>
              </div>
              }
            </div>
            } @else {
            <div
              class="mb-8 text-gray-500 text-sm py-3 px-4 bg-gray-50 rounded-lg text-center"
            >
              No saved languages
            </div>
            }
          </div>

          <!-- Conditions section - simplified -->
          <div
            class="conditions-section"
            [class.active]="selectedQuestionIndex !== null"
          >
            <h3 class="conditions-title">Conditions</h3>

            @if (selectedQuestionIndex !== null) {
            <!-- Mandatory answer checkbox -->
            <mat-checkbox
              class="condition-checkbox"
              [checked]="
                questions[selectedQuestionIndex].get('required')?.value
              "
              (change)="onMandatoryAnswerChange($event)"
            >
              Mandatory Answer
            </mat-checkbox>

            <!-- Add Sales Date Conditions for Sellout template -->
            @if (questions[selectedQuestionIndex].get('fieldTypeId')?.value ===
            7) {
            <div class="mt-4">
              <h4 class="text-sm font-medium text-gray-700 mb-2">
                Sales Date Conditions
              </h4>

              <mat-checkbox
                class="condition-checkbox"
                [checked]="salesDateValidations.selectCurrentPastOne"
                (change)="
                  onSalesDateConditionChange(
                    'selectCurrentPastOne',
                    $event.checked
                  )
                "
              >
                Select Current & Past One
              </mat-checkbox>

              <mat-checkbox
                class="condition-checkbox"
                [checked]="salesDateValidations.selectCurrentPast"
                (change)="
                  onSalesDateConditionChange(
                    'selectCurrentPast',
                    $event.checked
                  )
                "
              >
                Select Current & Past
              </mat-checkbox>

              <mat-checkbox
                class="condition-checkbox"
                [checked]="salesDateValidations.selectCurrentFutureOne"
                (change)="
                  onSalesDateConditionChange(
                    'selectCurrentFutureOne',
                    $event.checked
                  )
                "
              >
                Select Current & Future One
              </mat-checkbox>

              <mat-checkbox
                class="condition-checkbox"
                [checked]="salesDateValidations.selectCurrentFuture"
                (change)="
                  onSalesDateConditionChange(
                    'selectCurrentFuture',
                    $event.checked
                  )
                "
              >
                Select Current & Future
              </mat-checkbox>

              <mat-checkbox
                class="condition-checkbox"
                [checked]="salesDateValidations.selectCurrent"
                (change)="
                  onSalesDateConditionChange('selectCurrent', $event.checked)
                "
              >
                Select Current
              </mat-checkbox>
            </div>
            }

            <!-- Only show other conditions for non-sellout and non-store360 questions -->
            @if (questions[selectedQuestionIndex].get('fieldTypeId')?.value !==
            7 && questions[selectedQuestionIndex].get('fieldTypeId')?.value !==
            6) {
            <!-- File Upload specific conditions -->
            @if (questions[selectedQuestionIndex].get('fieldTypeId')?.value ===
            2) {
            <!-- Allow image from gallery -->
            <mat-checkbox
              class="condition-checkbox"
              [checked]="
                questions[selectedQuestionIndex].get('validation')?.value
                  ?.allowGallery
              "
              (change)="onConditionChange('allowGallery', $event.checked)"
            >
              Allow Image from Gallery
            </mat-checkbox>

            <!-- Multiple Images -->
            <mat-checkbox
              class="condition-checkbox"
              [checked]="
                questions[selectedQuestionIndex].get('validation')?.value
                  ?.allowMultiple
              "
              (change)="onConditionChange('allowMultiple', $event.checked)"
            >
              Multiple Images
            </mat-checkbox>

            <!-- Single Image -->
            <mat-checkbox
              class="condition-checkbox"
              [checked]="
                questions[selectedQuestionIndex].get('validation')?.value
                  ?.singleImage
              "
              (change)="onConditionChange('singleImage', $event.checked)"
            >
              Single Image
            </mat-checkbox>

            <!-- Ask for category -->
            <mat-checkbox
              class="condition-checkbox"
              [checked]="
                questions[selectedQuestionIndex].get('validation')?.value
                  ?.askCategory
              "
              (change)="onConditionChange('askCategory', $event.checked)"
            >
              Ask for Category
            </mat-checkbox>

            <!-- Ask for comment -->
            <mat-checkbox
              class="condition-checkbox"
              [checked]="
                questions[selectedQuestionIndex].get('validation')?.value
                  ?.askComment
              "
              (change)="onConditionChange('askComment', $event.checked)"
            >
              Ask for Comment
            </mat-checkbox>

            <!-- Embed tag -->
            <mat-checkbox
              class="condition-checkbox"
              [checked]="
                questions[selectedQuestionIndex].get('validation')?.value
                  ?.embedTag
              "
              (change)="onConditionChange('embedTag', $event.checked)"
            >
              Embed Tag
            </mat-checkbox>
            }

            <!-- Existing conditions for other question types -->
            @if (questions[selectedQuestionIndex].get('fieldTypeId')?.value !==
            2) {
            <!-- Accumulative graph checkbox -->
            <mat-checkbox
              class="condition-checkbox"
              [checked]="
                questions[selectedQuestionIndex].get('validation')?.value[0]
                  ?.accumulativeGraph
              "
              (change)="onConditionChange('accumulativeGraph', $event.checked)"
            >
              Accumulative Graph
            </mat-checkbox>

            <!-- Allow scoring checkbox -->
            <mat-checkbox
              class="condition-checkbox"
              [checked]="
                questions[selectedQuestionIndex].get('validation')?.value[0]
                  ?.allowScoring
              "
              (change)="onConditionChange('allowScoring', $event.checked)"
            >
              Allow Scoring
            </mat-checkbox>

            <!-- Show previous info checkbox -->
            <mat-checkbox
              class="condition-checkbox"
              [checked]="
                questions[selectedQuestionIndex].get('validation')?.value[0]
                  ?.showPreviousInfo
              "
              (change)="onConditionChange('showPreviousInfo', $event.checked)"
            >
              Show Previous Info
            </mat-checkbox>
            } } }
          </div>
        </div>
      </div>
    </mat-grid-tile>
    }
  </mat-grid-list>
</div>
